/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DistributeOnboardingCandidateRequestBody,
  DistributeOnboardingCandidateRequestBody$Outbound,
  DistributeOnboardingCandidateRequestBody$outboundSchema,
} from "../components/distributeonboardingcandidaterequestbody.js";

export type DistributePlatformMCPOnboardingCandidateSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DistributePlatformMCPOnboardingCandidateRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  distributeOnboardingCandidateRequestBody:
    DistributeOnboardingCandidateRequestBody;
};

/** @internal */
export type DistributePlatformMCPOnboardingCandidateSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DistributePlatformMCPOnboardingCandidateSecurity$outboundSchema:
  z.ZodMiniType<
    DistributePlatformMCPOnboardingCandidateSecurity$Outbound,
    DistributePlatformMCPOnboardingCandidateSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function distributePlatformMCPOnboardingCandidateSecurityToJSON(
  distributePlatformMCPOnboardingCandidateSecurity:
    DistributePlatformMCPOnboardingCandidateSecurity,
): string {
  return JSON.stringify(
    DistributePlatformMCPOnboardingCandidateSecurity$outboundSchema.parse(
      distributePlatformMCPOnboardingCandidateSecurity,
    ),
  );
}

/** @internal */
export type DistributePlatformMCPOnboardingCandidateRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  DistributeOnboardingCandidateRequestBody:
    DistributeOnboardingCandidateRequestBody$Outbound;
};

/** @internal */
export const DistributePlatformMCPOnboardingCandidateRequest$outboundSchema:
  z.ZodMiniType<
    DistributePlatformMCPOnboardingCandidateRequest$Outbound,
    DistributePlatformMCPOnboardingCandidateRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      distributeOnboardingCandidateRequestBody:
        DistributeOnboardingCandidateRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        distributeOnboardingCandidateRequestBody:
          "DistributeOnboardingCandidateRequestBody",
      });
    }),
  );

export function distributePlatformMCPOnboardingCandidateRequestToJSON(
  distributePlatformMCPOnboardingCandidateRequest:
    DistributePlatformMCPOnboardingCandidateRequest,
): string {
  return JSON.stringify(
    DistributePlatformMCPOnboardingCandidateRequest$outboundSchema.parse(
      distributePlatformMCPOnboardingCandidateRequest,
    ),
  );
}
